import { Link } from 'react-router-dom';
import { useLocale, useTranslate } from '../../application/i18n/LocaleProvider';
import { CompareIcon } from '../icons/ControlIcons';

/**
 * The way from one car to the duel (SPEC-008 PR-8.13).
 *
 * The duel lost its tab, and this is one of the two doors that replaced it. That
 * trade is only worth making because a door placed HERE is better than the tab
 * was: a tab drops the reader on a screen whose whole content is two cars they
 * have not chosen yet, and this one arrives with the first lane already filled
 * by the car they were looking at. The question the screen answers — how does
 * this compare — is one a reader only has while a car is in front of them.
 *
 * ONLY THE FIRST LANE. Naming the second would be this component picking the
 * reader's opponent for them, and `compareState` already has the better answer
 * for a lane nobody has named: the catalogue's own order, which is the order the
 * garage draws and so the pair they would have chosen first anyway.
 *
 * The id goes into the query unescaped, exactly as `carShareUrl` puts it into a
 * path. A car id is kebab-case by the schema and is the same string in the URL,
 * in the content JSON and on disk — and an id the catalogue cannot supply is
 * already a designed state on the other side rather than a broken screen.
 *
 * A `<Link>` and not a button, because it is a destination with an address: a
 * reader who wants it in a new tab, or wants to send it to somebody, should get
 * what every other link on this page gives them.
 */
export default function CarCompareLink({ car }) {
    const { localeCode } = useLocale();
    const t = useTranslate();

    return (
        <Link
            className="button button--quiet car-compare__action"
            to={`/${localeCode}/compare?a=${car.id}`}
        >
            <CompareIcon size={20} />
            {t('cars.compare.action')}
        </Link>
    );
}
